import { isVideoAccessible } from '$lib/utils/checkVideoAccess';
import type { SupabaseClient } from '@supabase/supabase-js';
import type { User } from '$lib/types/user';

export const getPlaylists = async (
	balancedSupabase: SupabaseClient,
	user: User | null,
	start: number,
	end: number
) => {
	console.log('getPlaylists called');
	const queryString = `
        *,
        videos:videos!playlists_videos(i, id, free, name, permalink_slug, exclude, vimeo_id, public_image_url)
    `;

	const {
		data: playlists,
		error,
		count
	} = await balancedSupabase
		.from('playlists')
		.select(queryString, { count: 'exact' })
		.is('user_id', null)
		.range(start, end)
		.order('order', { ascending: true })
		.order('created_at', { ascending: false });

	if (error) {
		console.error(error);
		return { data: [], count: 0 };
	}

	return {
		data: playlists.map((playlist) => ({
			...playlist,
			videos: playlist.videos.map((video) => ({
				...video,
				locked: !isVideoAccessible(video, user)
			}))
		})),
		count
	};
};
